module.exports = __webpack_public_path__ + "static/media/nature01.02c96c85.jpg";